'use es6';

import PositionedBetaButton from './PositionedBetaButton';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const OptLoading = () => {
  return /*#__PURE__*/_jsx(PositionedBetaButton, {
    icon: "none",
    "data-test-id": "positionedBetaButton",
    children: /*#__PURE__*/_jsx(UILoadingSpinner, {
      use: "on-dark"
    })
  });
};
export default OptLoading;